import { DATE_FORMAT } from '../common';
import TableCellFilted from '../common/componentUI/TableCellFilted';
import companyDispatcher from '../company/action';
import ageqReportDispatcher from './action';
import GroupToolbar from './component/GroupToolbar';
import { COLUMN_AGEQ_REPORT } from './constants';
import { ExportIcon } from '@/assets/svg';
// New component
import customToast from '@/new-components/CustomNotification';
import CustomPaperContainer from '@/new-components/CustomPaperContainer';
import CustomHeader from '@/new-components/CustomPaperContainer/CustomHeader';
import CustomTable from '@/new-components/CustomTable';
import CustomTooltip from '@/new-components/CustomTooltip';
import { TableHead, TableRow, TableCell, Button } from '@material-ui/core';
import { debounce, isEmpty } from 'lodash';
import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const AgeQReport = () => {
  const { list: data, paging } = useSelector((state) => state.ageqReport);
  const [orderList, setOrderList] = useState([]);

  const [locationFilter, setLocationFilter] = useState([]);
  const [listProjects, setListProjects] = useState([]);
  const [projectFilter, setProjectFilter] = useState('');
  const [dateRange, setDateRange] = useState([
    moment().startOf('month'),
    moment().endOf('date'),
  ]);
  const [filterOption, setFilterOption] = useState({
    fromDate: dateRange[0],
    toDate: dateRange[1],
  });

  useEffect(() => {
    return () => {
      ageqReportDispatcher.resetData();
    };
  }, []);

  useEffect(() => {
    setOrderList(data || []);
  }, [data]);

  useEffect(() => {
    if (!isEmpty(locationFilter)) {
      const locationIds = locationFilter.map((it) => it.id);
      companyDispatcher.getProjectByLocation(locationIds, (result) =>
        setListProjects(result)
      );
    }
  }, [locationFilter]);

  useEffect(() => {
    const dateOption = {
      startDate: dateRange[0] ? dateRange[0].toISOString() : undefined,
      endDate: dateRange[1] ? dateRange[1].toISOString() : undefined,
    };
    if (!isEmpty(projectFilter) && !isEmpty(locationFilter))
      setFilterOption({
        ...dateOption,
        projectIds: [projectFilter],
        locationIds: locationFilter.map((it) => it.id),
      });
    else if (!isEmpty(locationFilter))
      setFilterOption({
        ...dateOption,
        locationIds: locationFilter.map((it) => it.id),
      });
    else
      setFilterOption({
        ...dateOption,
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectFilter, locationFilter, dateRange]);

  const onResetFilterOps = () => {
    setLocationFilter([]);
    setProjectFilter('');
    setListProjects([]);
    setDateRange([]);
    setFilterOption({});
  };

  const onDateRangeChange = (startDate, endDate) => {
    if (startDate && endDate) {
      setDateRange([startDate, endDate]);
    } else {
      setDateRange([]);
    }
  };

  const fetchData = async (pagingData, filterOptionData = filterOption) => {
    ageqReportDispatcher.getDataAgeQReport(pagingData, filterOptionData);
  };

  const debounceLoadData = useCallback(
    debounce((paging, filterOption) => {
      fetchData(
        {
          pageIndex: 0,
          pageSize: paging.pageSize || 10,
        },
        filterOption
      );
    }, 500),
    []
  );

  useEffect(() => {
    debounceLoadData(paging, filterOption);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterOption]);

  const onExportExcel = () => {
    if (isEmpty(orderList)) {
      return customToast(
        'error',
        'There is no data available to export the excel file'
      );
    }
    ageqReportDispatcher.exportAgeQReport({
      ...filterOption,
    });
  };

  const TableHeader = () => (
    <TableHead>
      <TableRow>
        {COLUMN_AGEQ_REPORT.map((item) => (
          <TableCellFilted
            key={item.stateValue || item.label}
            label={item.label}
            stateValue={item.stateValue}
            style={{
              minWidth: item.minWidth || 'unset',
              maxWidth: item.maxWidth || 'unset',
              width: item.width || 'unset',
            }}
            isHidden={false}
          />
        ))}
      </TableRow>
    </TableHead>
  );

  const renderTableBody = (row) => {
    return (
      <>
        <TableCell>
          <CustomTooltip content={row.patientFullName} />
        </TableCell>
        <TableCell>{row.nric}</TableCell>
        <TableCell>
          {row.screeningDate
            ? moment(row.screeningDate).format(DATE_FORMAT)
            : ''}
        </TableCell>
      </>
    );
  };

  return (
    <CustomPaperContainer
      header={
        <CustomHeader
          title="AgeQ Report"
          isSearch={false}
          renderButton={() => (
            <Button
              color="primary"
              variant="outlined"
              startIcon={<ExportIcon width={20} height={20} />}
              onClick={onExportExcel}
            >
              Export
            </Button>
          )}
          renderToolbar={() => (
            <GroupToolbar
              dateRange={dateRange}
              onDateRangeChange={onDateRangeChange}
              onResetFilterOps={onResetFilterOps}
              locationFilter={locationFilter}
              setLocationFilter={setLocationFilter}
              listProjects={listProjects}
              setListProjects={setListProjects}
              projectFilter={projectFilter}
              setProjectFilter={setProjectFilter}
            />
          )}
        />
      }
    >
      <CustomTable
        data={orderList}
        paging={paging}
        header={TableHeader}
        renderRow={(row) => renderTableBody(row)}
        noDataHelperText="No AgeQ report"
        noDataHelperSubText="Please come back at another time."
        totalCols={COLUMN_AGEQ_REPORT.length}
        fetchData={fetchData}
        nameKey="id"
      />
    </CustomPaperContainer>
  );
};

export default AgeQReport;
